import React, { useState } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { GrPowerReset } from "react-icons/gr";
import { FaCirclePlus } from "react-icons/fa6";
import { MdCake } from "react-icons/md";
import { FaRegCalendarCheck, FaRegCalendarTimes } from "react-icons/fa";
import { HiMiniViewColumns } from "react-icons/hi2";
import { Spinner } from "react-bootstrap";
import { BiMaleFemale } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { createPatientEpisode } from "../CodingSupport/Redux/codingSupportSlicer";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

import "./CreatePatientEpisode.css";
import { toast } from "react-toastify";
import { Loader } from "../../../utils/Loader";
import { setcurrentClusterID } from "../../pages/Coder/redux/CoderSlicer";

// const inputList = [
//   { fieldName: 'Episode ID', type: 'str' },
//   { fieldName: 'Admission Date', type: 'date' },
//   { fieldName: 'Separation Date', type: 'date' },
//   { fieldName: 'Gender', type: 'options' },
//   { fieldName: 'Separation Mode', type: 'options' },
// ];

// const genderOptions = [
//   { value: 'Male', label: 'Male' },
//   { value: 'Female', label: 'Female' },
//   { value: 'Others', label: 'Others' },
// ];
const genderOptions = [
  { value: "U", label: "Unknown/Not Stated" },
  { value: "M", label: "Male" },
  { value: "F", label: "Female" },
  { value: "I", label: "Indeterminate/Another Term" },
];

const separationModeOptions = [
  {
    value: 10,
    label: "Discharge/transfer to another acute hospital",
  },
  {
    value: 21,
    label:
      "Discharge/transfer to a residential aged care service, which is not the usual place of residence",
  },
  {
    value: 22,
    label:
      "Discharge/transfer to a residential aged care service, which is the usual place of residence",
  },
  {
    value: 30,
    label: "Discharge/transfer to another psychiatric hospital",
  },
  {
    value: 40,
    label:
      "Discharge/transfer to other health care accommodation (includes mothercraft hospitals)",
  },
  {
    value: 50,
    label: "Statistical discharge – type change",
  },
  {
    value: 60,
    label: "Left against medical advice/discharge at own risk",
  },
  {
    value: 70,
    label: "Statistical discharge from leave",
  },
  {
    value: 80,
    label: "Died",
  },
  {
    value: 90,
    label:
      "Other (includes discharge to usual residence (not including residential aged care), own accommodation/welfare institution (includes prisons, hostels and group homes providing primarily welfare services))",
  },
];

const CreatePatientEpisode = () => {
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [admissionDate, setAdmissionDate] = useState(null);
  const [separationDate, setSeparationDate] = useState(null);
  const [gender, setGender] = useState(null);
  const [separationMode, setSeparationMode] = useState(null);

  const dispatch = useDispatch();
  const { loading, error, success } = useSelector(
    (state) => state.codingSupport.patientCreationState,
  );

  const navigate = useNavigate();
  const formatDate = (date) => {
    if (!date) return null;
    return date ? format(date, "yyyy-MM-dd") : null;
  };

  const handleSubmitPatientEpisodeForm = async (e) => {
    e.preventDefault();

    const payload = {
      date_of_birth: formatDate(dateOfBirth),
      sex: gender?.value[0] ?? "",
      admission_date: formatDate(admissionDate) ?? null,
      separation_date: formatDate(separationDate) ?? null,
      separation_mode: separationMode?.value ?? "",
    };

    dispatch(setcurrentClusterID("A"));
    sessionStorage.setItem(
      "diagnosisStates",
      JSON.stringify({ principal: [], additional: [], procedure: [] }),
    );
    sessionStorage.setItem("principalDiagnosisState", JSON.stringify([]));
    sessionStorage.setItem("additionalDiagnosisState", JSON.stringify([]));
    sessionStorage.setItem("procedureCodesState", JSON.stringify([]));
    try {
      const res = await dispatch(createPatientEpisode(payload)).unwrap();

      const lineId = res?.data?.hcp_line_id;
      const lineAssignementId = res?.data?.hcp_line_assignment_id;

      if (lineId && lineAssignementId) {
        sessionStorage.setItem("last_hcp_line_id", lineId);
        sessionStorage.setItem("activeTab", "ICD 10 AM Index");
        sessionStorage.setItem("activeIcon", "ICD");
        sessionStorage.setItem("showCodeSearch", "true");
        sessionStorage.setItem("episodeDetails", JSON.stringify({}));

        onHandleReset();
        toast.success("Patient Episode created");
        sessionStorage.setItem("currentPage", "coderview");
        const currentPage = sessionStorage.getItem("currentPage");
        if (currentPage === "coderview") {
          setTimeout(() => {
            navigate("/Code-Assist", {
              state: {
                hcp_line_id: lineId,
                line_assignment_id: lineAssignementId,
              },
            });
          }, 3000);
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };

  const onHandleReset = () => {
    setDateOfBirth(null);
    setAdmissionDate(null);
    setSeparationDate(null);
    setGender(null);
    setSeparationMode(null);
  };

  return (
    <div className="w-100 create-patient-section">
      <div className="d-flex flex-column align-center mt-4">
        <h1 className="create-patient-episode-title">Patient Episode</h1>
        <p className="create-patient-episode-description">
          Provide patient details to create a new episode.
        </p>
        <form
          className="create-patient-episode-form-container"
          onSubmit={(e) => handleSubmitPatientEpisodeForm(e)}
        >
          <div className="create-patient-episode-input-conrainer">
            <div className="create-patient-episode-each-input-container ">
              <div className="create-patient-episode-label-container">
                <div>
                  <MdCake className="create-patient-episode-optionicons" />
                </div>
                <label className="create-patient-episode-label">
                  Date of Birth
                  <span className="create-patient-episode-required-label">
                    *
                  </span>
                </label>
              </div>
              <DatePicker
                selected={dateOfBirth}
                onChange={(date) => setDateOfBirth(date)}
                placeholderText="dd/mm/yy"
                dateFormat="dd/MM/yy"
                className="create-patient-episode-each-input"
                popperPlacement="bottom-start"
                portalId="root"
                showMonthDropdown
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                maxDate={new Date()}
                onKeyDown={(e) => e.preventDefault()}
                isClearable
                required
              />
            </div>

            <div className="create-patient-episode-each-input-container ">
              <div className="create-patient-episode-label-container">
                <div>
                  <FaRegCalendarCheck className="create-patient-episode-optionicons" />
                </div>
                <label className="create-patient-episode-label">
                  Admission Date
                  <span className="create-patient-episode-required-label">
                    *
                  </span>
                </label>
              </div>
              <DatePicker
                selected={admissionDate}
                // onSelect={handleDateSelect}
                onChange={(date) => setAdmissionDate(date)}
                placeholderText="dd/mm/yy"
                dateFormat="dd/MM/yy"
                className="create-patient-episode-each-input"
                minDate={dateOfBirth}
                maxDate={new Date()}
                popperPlacement="bottom-start"
                portalId="root"
                showMonthDropdown
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                onKeyDown={(e) => e.preventDefault()}
                isClearable
                required
              />
            </div>

            <div className="create-patient-episode-each-input-container">
              <div className="create-patient-episode-label-container">
                <div>
                  <FaRegCalendarTimes className="create-patient-episode-optionicons" />
                </div>
                <label className="create-patient-episode-label">
                  Separation Date
                  <span className="create-patient-episode-required-label">
                    *
                  </span>
                </label>
              </div>
              <DatePicker
                selected={separationDate}
                // onSelect={handleDateSelect}
                onChange={(date) => setSeparationDate(date)}
                placeholderText="dd/mm/yy"
                dateFormat="dd/MM/yy"
                minDate={admissionDate ?? dateOfBirth}
                maxDate={new Date()}
                className="create-patient-episode-each-input"
                popperPlacement="bottom-start"
                portalId="root"
                showMonthDropdown
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                onKeyDown={(e) => e.preventDefault()}
                isClearable
                required
              />
            </div>

            <div className="create-patient-episode-each-input-container">
              <div className="create-patient-episode-label-container">
                <div>
                  <BiMaleFemale className="create-patient-episode-optionicons" />
                </div>
                <label className="create-patient-episode-label">
                  Gender
                  <span className="create-patient-episode-required-label">
                    *
                  </span>
                </label>
              </div>
              <Select
                options={genderOptions}
                placeholder="Select Gender"
                value={gender}
                onChange={(selected) => setGender(selected)}
                classNamePrefix="create-patient-episode-custom-select"
                isClearable
                required
              />
            </div>

            <div className="create-patient-episode-each-input-container">
              <div className="create-patient-episode-label-container ">
                <div>
                  <HiMiniViewColumns className="create-patient-episode-optionicons" />
                </div>
                <label className="create-patient-episode-label">
                  Separation Mode
                </label>
              </div>
              <Select
                options={separationModeOptions}
                placeholder="Select Separation Mode"
                value={separationMode}
                onChange={(selected) => setSeparationMode(selected)}
                formatOptionLabel={(option) =>
                  `${option.value} : ${option.label}`
                }
                isClearable
                classNamePrefix="create-patient-episode-custom-select"
              />
            </div>
          </div>
          <div className="create-patient-episode-btn-container">
            <button
              type="button"
              onClick={onHandleReset}
              className="create-patient-episode-reset-btn"
            >
              <span>
                <GrPowerReset className="create-patient-episode-icons" />
              </span>
              Reset
            </button>
            <button
              type="submit"
              className="btn create-patient-episode-submit-btn"
            >
              {loading ? (
                <Spinner size="sm" />
              ) : (
                <>
                  <span>
                    <FaCirclePlus className="create-patient-episode-icons" />
                  </span>
                  Create Patient Episode
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePatientEpisode;
